/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

export enum GroupBy {
	Off = 'off',
	Location = 'location',
	Swimlane = 'swimlane',
	Wbs = 'wbs',
}

//formControls and their silly values
export function enableSortGroupsBy(val: GroupBy | undefined | null | '') {
	return val ? val !== GroupBy.Off : false;
}

export function enableWbsGroupingLevel(val: GroupBy | undefined | null | '') {
	return val === GroupBy.Wbs;
}
